import React from "react";
import {
	MarketplaceCollection,
	MarketplaceCollectionRoute
} from "@/Contracts/Marketplace";
import { VendorSubscriptionStatus } from "@/Contracts/Marketplace/Vendor";
import { EColors } from "@atoms/ZColors/interface";
import Tag from "antd/lib/tag";
import ZTypography from "@atoms/ZTypography";
import { EFontWeights } from "@atoms/ZTypography/interface";
import {
	acceptPartnerProgramInvite,
	joinVendorProgram
} from "@/Services/Marketplace";
import { ZModal, ZTag } from "@atoms";
import DoneVector from "@/Assets/Others/doneVector.svg";
import { Row } from "antd";
import ZMessage from "@molecules/ZMessage";
import { capitalizeFirstLetter } from "@/Contracts/Utils";

export const getMarketplaceCollectionfromMarketplaceRoute = (
	collectionRoute?: MarketplaceCollectionRoute
) => {
	switch (collectionRoute) {
		case MarketplaceCollectionRoute.JOINEDPROGRAM:
			return MarketplaceCollection.JOINEDPROGRAM;
		default:
			return null;
	}
};

export const productSubscriptionTag = (subscription_status: string) => {
	if (subscription_status === VendorSubscriptionStatus.ACCEPTED) {
		return (
			<Tag className="joined-tag" color={EColors.GREEN}>
				Joined
			</Tag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.APPLIED) {
		return (
			<Tag className="joined-tag" color={EColors.BLUE}>
				Requested
			</Tag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.REJECTED) {
		return (
			<Tag className="joined-tag" color={EColors.RED}>
				Rejected
			</Tag>
		);
	}
	return null;
};

export const vendorSubscriptionTag = (
	subscription_status = VendorSubscriptionStatus.NOTAPPLIED
) => {
	if (subscription_status === VendorSubscriptionStatus.ACCEPTED) {
		return (
			<ZTag className="joined-tag" color={EColors.GREEN}>
				Joined
			</ZTag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.APPLIED) {
		return (
			<ZTag className="joined-tag" color={EColors.BLUE}>
				Requested
			</ZTag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.INVITED) {
		return (
			<ZTag className="joined-tag" color={EColors.BLUE}>
				Invited
			</ZTag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.REJECTED) {
		return (
			<ZTag className="joined-tag" color={EColors.RED}>
				Rejected
			</ZTag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.SUSPENDED) {
		return (
			<ZTag className="joined-tag" color="error">
				Suspended by Vendor
			</ZTag>
		);
	} else if (subscription_status === VendorSubscriptionStatus.WITHDRAWN) {
		return (
			<ZTag className="joined-tag" color={EColors.ORANGE}>
				Request Withdrawn
			</ZTag>
		);
	}
	return null;
};

export const onJoinVendorClick = async (
	vendorCompanyId?: string | null,
	vendorName?: string
) => {
	await joinVendorProgram(vendorCompanyId as string);
	ZModal.info({
		title: (
			<ZTypography.ZText level={2} weight={EFontWeights.MEDIUM}>
				Requested to join {vendorName}
			</ZTypography.ZText>
		),
		content: (
			<Row align="middle" justify="center" className="text-center">
				<Row className="mt-4">
					<DoneVector />
				</Row>
				<Row className="mt-8 mb-1 w-full" justify="center">
					<ZTypography.ZText level={2} weight={EFontWeights.MEDIUM}>
						Thank you for applying to {vendorName}
					</ZTypography.ZText>
				</Row>
				<Row>
					<ZTypography.ZText>
						Once {vendorName} accepts your request, you will be able
						to add this product SKU.
					</ZTypography.ZText>
				</Row>
			</Row>
		),
		okText: "Done",
		width: 600,
		closable: true,
		icon: "",
		okButtonProps: {
			ghost: true
		}
	});
};

export const acceptPartnerProgramInviteCallback = async (
	vendorName: string,
	vendorId: string
) => {
	try {
		await acceptPartnerProgramInvite(vendorId);
		ZMessage.success(
			`Invitation Accepted for ${capitalizeFirstLetter(vendorName)}`
		);
	} catch (error) {
		console.error(error);
	}
};
